import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import template from './template.html'
import PublishDate from '~/reactapp/App/PublishDate'

export default {
  restrict: 'E',
  template,
  replace: true,
  bindToController: true,
  controllerAs: 'vm',
  controller: [
    '$scope',
    '$element',
    '$rootScope',
    '$ngRedux',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    publishDateController,
  ],
  bindings: {
    isRequired: '=',
  },
}

function publishDateController($scope, $element, $rootScope, $ngRedux) {
  const rootElement = $element.find('#publish-date')[0]
  $scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootElement))
  this.$onInit = () => {
    ReactDOM.render(
      <Provider store={$ngRedux}>
        <PublishDate isRequired={Boolean($scope.isRequired)} />
      </Provider>,
      rootElement
    )
  }
}
